export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const TREATMENTS = [
  {
    id: "laser-treatments",
    name: "Laser Skin Therapy",
    tag: "Resurfacing & Tone",
    desc: "Targeted laser energy to rebuild collagen fibres, soften vascular redness and refine uneven texture — calibrated to your skin, never a preset.",
    downtime: "1–3 days",
    duration: "45 mins",
  },
  {
    id: "microneedling",
    name: "Precision Microneedling",
    tag: "Collagen Induction",
    desc: "Micro-channels awaken your skin's own healing cascade, softening fine lines and acne scarring over a course of unhurried sessions.",
    downtime: "24 hours",
    duration: "60 mins",
  },
  {
    id: "chemical-peels",
    name: "Bio-Chemical Peels",
    tag: "Dermal Renewal",
    desc: "Customised AHA, BHA and TCA formulations that lift away dull, tired surface cells and reveal the radiant skin beneath.",
    downtime: "0–2 days",
    duration: "30 mins",
  },
  {
    id: "hydrafacial",
    name: "Hydrafacial Deep Infusion",
    tag: "Hydration & Cleanse",
    desc: "Vortex extraction paired with antioxidant and hyaluronic micro-infusions. The deep clean your skin has been asking for.",
    downtime: "None",
    duration: "45 mins",
  },
  {
    id: "dermaplaning",
    name: "Dermaplaning Polish",
    tag: "Exfoliation & Glow",
    desc: "A gentle surgical-blade exfoliation that removes vellus hair and dead cells, leaving skin silk-smooth and product-ready.",
    downtime: "None",
    duration: "30 mins",
  },
  {
    id: "ipl-treatment",
    name: "IPL Photofacial",
    tag: "Pigment & Redness",
    desc: "Intense Pulsed Light that targets stubborn hyperpigmentation, acne marks and visible vascular lesions at their source.",
    downtime: "None",
    duration: "45 mins",
  },
  {
    id: "permanent-hair-removal",
    name: "Permanent Hair Removal",
    tag: "Laser Epilation",
    desc: "Advanced dual-wavelength laser reaches follicles at root depth, with integrated cooling for a genuinely comfortable session.",
    downtime: "None",
    duration: "30–60 mins",
  },
];

export const CHAPTERS = [
  {
    number: "01",
    title: "Honest consultation, always",
    desc: "We map your skin's biology before recommending a single laser pulse or needle. If a treatment won't serve you, we'll tell you — and tell you what will.",
  },
  {
    number: "02",
    title: "Clinical rigour, spa calm",
    desc: "Medical-grade efficacy delivered in an unhurried, serene sanctuary. No fluorescent-lit rush, no conveyor belt of clients.",
  },
  {
    number: "03",
    title: "Long-term skin health",
    desc: "We protect your skin barrier first. Lasting dermal health always wins over a harsh, short-lived cosmetic fix.",
  },
];

export const TESTIMONIALS = [
  {
    author: "Elena R.",
    treatment: "IPL & Chemical Peel",
    quote: "Luviae faded hyperpigmentation I'd battled for six years — and never once pushed a package on me. It feels like a sanctuary, not a sales floor.",
    rating: 5,
  },
  {
    author: "Sophia M.",
    treatment: "Precision Microneedling",
    quote: "After three sessions my post-acne texture is smoother than it's been in a decade. Thorough, gentle, and completely honest about what to expect.",
    rating: 5,
  },
  {
    author: "Clara V.",
    treatment: "Hydrafacial & Dermaplaning",
    quote: "The most relaxing yet effective treatment I've ever had. My skin stayed hydrated for weeks and I've already rebooked.",
    rating: 5,
  },
];

export const CONTACTS = {
  phone: "(647) 571-0638",
  phoneHref: "tel:+16475710638",
  email: "glow@aestheticsluviae.com",
  emailHref: "mailto:glow@aestheticsluviae.com",
  address: "4257 Sherwoodtowne Blvd, Mississauga, Ontario, L4Z 1Y5",
  domain: "aestheticsluviae.com",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1551184451-76b762941ad6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHozfHxza2luY2FyZSUyMGdsb3dpbmclMjBjbGVhciUyMHNraW4lMjBwb3J0cmFpdCUyMG5hdHVyYWwlMjBnbG93fGVufDB8fHx8MTc4OTMyMzg5OXww&ixlib=rb-4.1.0&q=85",
  sanctuary: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxzcGElMjBhZXN0aGV0aWMlMjBza2luY2FyZSUyMHRyZWF0bWVudCUyMGxhc2VyJTIwZmFjaWFsJTIwbWljcm9uZWVkbGluZ3xlbnwwfHx8fDE3ODkzMjM4OTJ8MA&ixlib=rb-4.1.0&q=85",
  mask: "https://images.unsplash.com/photo-1731514771613-991a02407132?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxzcGElMjBhZXN0aGV0aWMlMjBza2luY2FyZSUyMHRyZWF0bWVudCUyMGxhc2VyJTIwZmFjaWFsJTIwbWljcm9uZWVkbGluZ3xlbnwwfHx8fDE3ODkzMjM4OTJ8MA&ixlib=rb-4.1.0&q=85",
  peel: "https://images.unsplash.com/photo-1713085085470-fba013d67e65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxzcGElMjBhZXN0aGV0aWMlMjBza2luY2FyZSUyMHRyZWF0bWVudCUyMGxhc2VyJTIwZmFjaWFsJTIwbWljcm9uZWVkbGluZ3xlbnwwfHx8fDE3ODkzMjM4OTJ8MA&ixlib=rb-4.1.0&q=85",
  portrait1: "https://images.unsplash.com/photo-1581182800629-7d90925ad072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxza2luY2FyZSUyMGdsb3dpbmclMjBjbGVhciUyMHNraW4lMjBwb3J0cmFpdCUyMG5hdHVyYWwlMjBnbG93fGVufDB8fHx8MTc4OTMyMzg5OXww&ixlib=rb-4.1.0&q=85",
  portrait2: "https://images.unsplash.com/photo-1577746838851-816a43ca8733?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxza2luY2FyZSUyMGdsb3dpbmclMjBjbGVhciUyMHNraW4lMjBwb3J0cmFpdCUyMG5hdHVyYWwlMjBnbG93fGVufDB8fHx8MTc4OTMyMzg5OXww&ixlib=rb-4.1.0&q=85",
  portrait3: "https://images.unsplash.com/photo-1581182815808-b6eb627a8798?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxza2luY2FyZSUyMGdsb3dpbmclMjBjbGVhciUyMHNraW4lMjBwb3J0cmFpdCUyMG5hdHVyYWwlMjBnbG93fGVufDB8fHx8MTc4OTMyMzg5OXww&ixlib=rb-4.1.0&q=85",
};
